import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component , NO_ERRORS_SCHEMA } from '@angular/core';
import { FaqService } from '@services/faq.service';
import{ NavigationService } from '@services/navigation.service';
import { PolicyDataService } from '@services/data-services/policy-data.service';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule],
  selector: 'app-faq-autopay',
  templateUrl: './faq-autopay.component.html',
  styleUrls: ['./faq-autopay.component.scss']  
})
export class FaqAutopayComponent{
  accordianWithMDB: any = {};
  isSimplifiedPayPlan = false;

  constructor(
    private faqService: FaqService,
    private navService: NavigationService,
    private policyDataService: PolicyDataService
  ) {
    this.accordianWithMDB = this.faqService.getAccordianWithMDB();
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
          if (policyResponse && policyResponse.length > 0) {
            const policy = policyResponse.find((pol) => pol.isSimplifiedPayPlan);
            this.isSimplifiedPayPlan = policy?.isSimplifiedPayPlan;
          }    
        });
  }

  closeNonActiveCollapse(name): void {
    const acc = this.accordianWithMDB;
    for (const element in acc) {
      if (element != name) {
        acc[element] = false;
      }
    }
    acc[name] = !acc[name];
  }

  onClickBack(){
    this.navService.navigateBack();
  }
}
